import React, { useState, useEffect } from "react";
import "./TeamMemberCard.scss";
import { Fade } from "react-reveal";

export default function TeamMemberCard({ cardInfo, isDark }) {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const updateMobileStatus = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    updateMobileStatus();
    window.addEventListener("resize", updateMobileStatus);
    return () => window.removeEventListener("resize", updateMobileStatus);
  }, []);

  function handleCardFlip() {
    setIsFlipped(!isFlipped);
  }

  // Prevent flip when clicking LinkedIn link
  function handleLinkClick(e) {
    e.stopPropagation(); // Ensure the click doesn’t bubble up
  }

  const defaultImage = `${process.env.PUBLIC_URL}/assets/images/team/default-profile.jpg`;
  const imageSrc = imageError || !cardInfo.image ? defaultImage : cardInfo.image;

  return (
    <Fade bottom duration={1000} distance="20px">
      <div
        className={`team-card-container ${isFlipped ? "flipped" : ""} ${
          isMobile ? "mobile-view" : ""
        }`}
      >
        <div className={`team-card ${isDark ? "dark-mode" : ""}`}>
          {isMobile ? (
            <div className="team-card-static team-card-mobile-no-image">
              <div className="team-detail-div">
                <h3 className={`team-card-title ${isDark ? "dark-mode" : ""}`}>
                  {cardInfo.name}
                </h3>
                <p className={`team-card-role ${isDark ? "dark-mode" : ""}`}>
                  {cardInfo.role}
                </p>
                <div className="team-mobile-bio-section">
                  <p className={`team-card-bio ${isDark ? "dark-mode" : ""}`}>
                    {cardInfo.bio}
                  </p>
                  {cardInfo.linkedin && (
                    <div
                      className={`team-card-contact ${isDark ? "dark-mode" : ""}`}
                    >
                      <a
                        href={cardInfo.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleLinkClick}
                      >
                        <i className="fab fa-linkedin"></i> LinkedIn
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="team-card-front">
                <div className="team-image-div">
                  <img
                    src={imageSrc}
                    alt={`${cardInfo.name}`}
                    className="team-card-image"
                    loading="lazy"
                    onError={() => setImageError(true)}
                  />
                </div>
                <div className="team-detail-div">
                  <h3 className={`team-card-title ${isDark ? "dark-mode" : ""}`}>
                    {cardInfo.name}
                  </h3>
                  <p className={`team-card-role ${isDark ? "dark-mode" : ""}`}>
                    {cardInfo.role}
                  </p>
                </div>
                <div className="team-card-footer" onClick={handleCardFlip}>
                  <p className="flip-prompt">Click to see bio</p>
                </div>
              </div>
              <div className="team-card-back">
                <div className="team-back-content">
                  <h3 className={`team-card-title ${isDark ? "dark-mode" : ""}`}>
                    {cardInfo.name}
                  </h3>
                  <p className={`team-card-bio ${isDark ? "dark-mode" : ""}`}>
                    {cardInfo.bio}
                  </p>
                  {cardInfo.linkedin && (
                    <div
                      className={`team-card-contact ${isDark ? "dark-mode" : ""}`}
                    >
                      <a
                        href={cardInfo.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleLinkClick}
                      >
                        <i className="fab fa-linkedin"></i> LinkedIn
                      </a>
                    </div>
                  )}
                </div>
                <div className="team-card-footer" onClick={handleCardFlip}>
                  <p className="flip-prompt">Click to flip back</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </Fade>
  );
}